import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-430124a0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "progress-bar-container" };
const _hoisted_2 = { class: "progress-total-usage-label" };
const _hoisted_3 = {
    key: 0,
    class: "progress-label"
};
const _hoisted_4 = {
    key: 1,
    class: "progress-label"
};
const _hoisted_5 = { class: "progress-bar" };
import { HardDriveIcon } from '@gohighlevel/ghl-icons/24/outline';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ProgressBar',
    props: {
        totalUsed: {},
        segments: {},
        isLoading: { type: Boolean }
    },
    setup(__props) {
        const { t } = useI18n();
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(HardDriveIcon), { class: "w-5 h-5 mr-2" }),
                    (!(props === null || props === void 0 ? void 0 : props.isLoading))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(props === null || props === void 0 ? void 0 : props.totalUsed) + " used", 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)('common.calculating')) + "...", 1 /* TEXT */))
                ]),
                _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props === null || props === void 0 ? void 0 : props.segments, (segment, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "progress-segment",
                            style: _normalizeStyle({ width: segment.width + '%', backgroundColor: segment.color })
                        }, null, 4 /* STYLE */));
                    }), 128 /* KEYED_FRAGMENT */))
                ])
            ]));
        };
    }
});
